<template>
  <div class="leilao">
    <v-container
      class="lighten-5 mt-6 mb-6 pb-16"
      fluid
    >
      <v-row class="leilao__row">
        <v-col
          class="leilao__left"
          md="12"
          lg="3"
        >
          <v-navigation-drawer
            permanent
            width="100%"
          >
            <v-card-title>
              Filtros:
            </v-card-title>
            <v-card-text>
              <v-select
                :items="orderBy"
                label="Ordenar por:"
                chips
                persistent-hint
              ></v-select>
              <v-select
                :items="artistics"
                label="Artistas"
                multiple
                chips
                persistent-hint
              ></v-select>
              <v-select
                :items="categorys"
                label="Categoria"
                multiple
                chips
                persistent-hint
              ></v-select>
            </v-card-text>
          </v-navigation-drawer>
        </v-col>
        <v-col class="leilao__right">
          <v-row no-gutters>
            <v-col>
              <div class="fill-height pa-2">
                <Heading
                  font-size="48px"
                  line-height="72px"
                  letter-spacing="-0.015em"
                  font-color="#EE396C"
                  class="leilao__title"
                >
                  Destaque do Leilão:
                </Heading>
                <Heading
                  font-size="36px"
                  line-height="50px"
                  letter-spacing="-0.015em"
                  font-color="rgba(0,0,0,0.8)"
                  class="mt-2 leilao__subtitle"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                  incididunt ut labore
                </Heading>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <div class="fill-height pa-2">
                <v-row>
                  <v-col
                    v-for="(card, index) in auctions"
                    :key="index"
                    md="12"
                    lg="12"
                    sm="12"
                    class="flex-center"
                  >
                    <UpcomingAuctionsCard
                      :card="card"
                      max-img-width="100%"
                      max-img-height="100%"
                      border="1px solid #F2F2F2"
                      @click="gotoLeilao(card)"
                    >
                    </UpcomingAuctionsCard>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import RegisterMixin from '@/mixins/RegisterMixin';
import Heading from '@/components/Heading/Heading.vue';
import UpcomingAuctionsCard from '@/components/UpcomingAuctions/UpcomingAuctionsCard.vue';
import AuctionsService from '@/services/AuctionsService';

export default {
  name: 'Home',
  components: { Heading, UpcomingAuctionsCard },
  mixins: [RegisterMixin],
  data() {
    return {
      orderBy: ['A-Z', 'Destaques', 'Data de Início'],
      artistics: ['Artista 1', 'Artista 2', 'Artista 3', 'Artista 4', 'Artista 5'],
      categorys: ['Categoria 1', 'Categoria 2', 'Categoria 3', 'Categoria 4', 'Categoria 5'],
    };
  },
  computed: {
    ...mapState('Data/Auctions', [
      'auction',
      'auctions',
    ]),
    currentRoute() {
      return this.$route.name;
    },
    userData() {
      return this.$store.state.Data.User.profile;
    },
  },
  created() {
    AuctionsService.getAuctions()
      .then((result) => {
        throw result;
      })
      .catch((error) => {
        throw error;
      });
  },
  methods: {
    gotoLeilao(auction) {
      AuctionsService.setAuction(auction);
      this.$router.push({
        name: this.$consts.ROUTES.LEILAO.NAME,
        params: {
          leilao: auction.slug,
        },
      });
    },
    logOut() {
      this.$router.push({ name: this.$consts.ROUTES.AUTH_LOGIN.NAME });
    },
  },
};
</script>
<style lang="scss">
@import '@/static/css/Variables.scss';
.leilao {
  .flex-center {
    @media (max-width: $xl) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  &__title {
    @media (max-width: $md) {
      font-size: 26px !important;
      line-height: 30px !important;
    }
  }
  &__subtitle {
    @media (max-width: $md) {
      font-size: 16px !important;
      line-height: 20px !important;
    }
  }

  &__row {
    @media (max-width: $xl) {
      display: flex;
      flex-direction: column;
    }
  }

  &__left {
    @media (max-width: $xl) {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
